module.exports = __webpack_public_path__ + "media/images/icon__infoBox@2x-1cefdd6cccaf6bc54bd92d705e499062.png";